<router-outlet />
@if (loadingService.loading()) {
  <app-loading [message]="loadingService.message()" />
}
@if (toasts(); as toasts) {
  @for (
    position of [
      'top-left',
      'top-center',
      'top-right',
      'bottom-left',
      'bottom-center',
      'bottom-right',
    ];
    track position
  ) {
    @if (filterToasts(toasts, $any(position)); as zoneToasts) {
      @if (zoneToasts.length) {
        <div class="app-toast-zone" [class]="'app-toast-zone--' + position">
          @for (toast of zoneToasts; track toast.id) {
            <app-toast
              animate.leave="app-toast--leaving"
              [title]="toast.title"
              [message]="toast.message"
              [tone]="toast.tone!"
              [position]="toast.position!"
              [isProcess]="toast.isProcess!"
              [showLeftIcon]="toast.showLeftIcon!"
              [showHeader]="toast.showHeader!"
              [showMessage]="toast.showMessage!"
              (closeToast)="removeToast(toast.id!)" />
          }
        </div>
      }
    }
  }
}
